import React from "react";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";

import PriceColumnTitle from "components/rates_table/price_column_title";

import RatesTableHeaderColumn from "./rates_table_header_column";

import styles from "./rates_table_header.module.scss";

export default function RatesTableHeader({ checkinDate, checkoutDate, propertyUnits, propertyType }) {
  const { t } = useTranslation();
  const isCheckinDateValid = checkinDate && dayjs(checkinDate).isValid();
  const isCheckoutDateValid = checkoutDate && dayjs(checkoutDate).isValid();
  const isEnteredDatesValid = isCheckinDateValid && isCheckoutDateValid;
  const residenceTime = isEnteredDatesValid ? checkoutDate.diff(checkinDate, "days") : null;

  const isRatesPresent = propertyUnits.some((room) => {
    return Array.isArray(room.ratePlans) && room.ratePlans.length > 0;
  });

  return (
    <div className={styles.tableHeaderWrapper}>
      <RatesTableHeaderColumn>{t(`rates_table_${propertyType}.unit_type`)}</RatesTableHeaderColumn>
      {isRatesPresent && (
        <>
          <RatesTableHeaderColumn className={styles.columnNarrow}>
            {t(`rates_table_${propertyType}.occupants`)}
          </RatesTableHeaderColumn>
          <RatesTableHeaderColumn>
            <PriceColumnTitle residenceTime={residenceTime} propertyType={propertyType} />
          </RatesTableHeaderColumn>
          <RatesTableHeaderColumn>{t("rates_table.your_choises")}</RatesTableHeaderColumn>
          <RatesTableHeaderColumn className={styles.columnNarrow}>
            {t(`rates_table_${propertyType}.units`)}
          </RatesTableHeaderColumn>
        </>
      )}
    </div>
  );
}
